export type OrigemAbaCredito = 'dividas' | 'emprestimos';

export type VinculoDeclarado = 'sim' | 'nao' | 'talvez';
export type IntencaoDeclarada = 'contratar' | 'olhando';

export const MOTIVOS_BLOQUEIO_CREDITO = ['sem_vinculo_clt', 'so_olhando', 'limite_simulacoes'] as const;

export type MotivoBloqueioCredito = (typeof MOTIVOS_BLOQUEIO_CREDITO)[number];
